import CompaniesService from "@/services/CompaniesService";

const getDefaultState = () => ({
    companies: [],
});

export default {
    state: () => getDefaultState(),
    getters: {
        getCompanies: state => state.companies,
    },
    mutations: {
        setCompanies: (state, companies) => {
            state.companies = companies;
        },
        setCompaniesState: state => {
            Object.assign(state, getDefaultState());
        },
    },
    actions: {
        processCompanies: async ({ dispatch, commit }) => {
            try {
                commit("setLoading", true);
                const response = await CompaniesService.get();
                commit("setCompanies", response.data.data);
            } catch (e) {
                if (e.response.data.message === "Objects were not found") {
                    commit("setCompanies", []);
                } else {
                    dispatch("generalErrorHandling", e);
                }
            } finally {
                commit("setLoading", false);
            }
        },

        addCompany: async ({ dispatch, commit }, company) => {
            try {
                commit("setLoading", true);
                await CompaniesService.create(company);
                await dispatch("processCompanies");
                commit({
                    type: "alert",
                    text: "New company saved",
                    color: "primary",
                    icon: "save",
                });
            } catch (e) {
                dispatch("generalErrorHandling", e);
            } finally {
                commit("setLoading", false);
            }
        },

        editCompany: async ({ dispatch, commit }, company) => {
            try {
                commit("setLoading", true);
                await CompaniesService.update(company.id, company);
                await dispatch("processCompanies");
                commit({
                    type: "alert",
                    text: "Company changes saved",
                    color: "primary",
                    icon: "save",
                });
            } catch (e) {
                dispatch("generalErrorHandling", e);
            } finally {
                commit("setLoading", false);
            }
        },

        deleteCompany: async ({ dispatch, commit }, id) => {
            try {
                commit("setLoading", true);
                await CompaniesService.delete(id);
                await dispatch("processCompanies");
                commit({
                    type: "alert",
                    text: "Company deleted",
                    color: "error",
                    icon: "delete_sweep",
                });
            } catch (e) {
                dispatch("generalErrorHandling", e);
            } finally {
                commit("setLoading", false);
            }
        },

        resetCompaniesState: ({ commit }) => {
            commit("setCompaniesState");
        },
    },
};
